import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExclamation} from '@fortawesome/free-solid-svg-icons';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

import './styles.scss';

interface IProfilePictureInvalidProps {
    className?: string;
}

export const ProfilePictureInvalid = ({className}: IProfilePictureInvalidProps) => {
    const {t, ready} = useTranslation('common', {useSuspense: false});

    const tooltipText = (ready) ? t('errors.imageLoad', 'Image failed to load') : 'Image failed to load';
    const tooltip = (
        <Tooltip id="ProfilePictureError">{tooltipText}</Tooltip>
    );
    const overlayClassName = `${className} d-inline-flex justify-content-center align-items-center`;

    // this unusual syntax avoids calls to `React.findDOMNode` which cause issues when running in "strict" mode
    // see: https://react-bootstrap.github.io/components/overlays/#customizing-trigger-behavior
    return (
        <OverlayTrigger transition={false} placement="top" overlay={tooltip}>
            {({ref, ...triggerHandler}) => (
                <div {...triggerHandler} ref={ref ?? undefined} className={overlayClassName}>
                    <FontAwesomeIcon icon={faExclamation} className="ProfilePicture__error-icon"/>
                </div>
            )}
        </OverlayTrigger>
    );
};
